import type {
  LeadTimeStrategyBuilder,
  LeadTimeStrategyResultBuilder,
} from '@calculations/lead-time/builders';

export const PlanningLeadTime = 'PlanningLeadTime' as const;

export type PlanningLeadTime = typeof PlanningLeadTime;

export type PlanningLeadTimeLeadTimeStrategy = LeadTimeStrategyBuilder<
  PlanningLeadTime,
  {
    planningDaysPerWeek: number;
  }
>;

export type PlanningLeadTimeLeadTimeStrategyResult =
  LeadTimeStrategyResultBuilder<PlanningLeadTime>;
